import React from 'react';
import { X } from 'lucide-react';

interface WorkflowFeedbackProps {
  message: string;
  onDismiss: () => void;
  className?: string;
}

const WorkflowFeedback: React.FC<WorkflowFeedbackProps> = ({
  message,
  onDismiss,
  className,
}) => {
  const ref = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (!message) return;
    requestAnimationFrame(() => {
      ref.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  }, [message]);

  if (!message) return null;

  return (
    <div
      ref={ref}
      className={`success-message workflow-feedback ${className || ''}`.trim()}
      role="status"
      aria-live="polite"
    >
      <span>{message}</span>
      <button
        className="icon-button"
        type="button"
        aria-label="Dismiss success message"
        onClick={onDismiss}
      >
        <X size={16} aria-hidden="true" />
      </button>
    </div>
  );
};

export default WorkflowFeedback;
